import React from 'react';
import { heroImageUrl } from '../../utils/heroImageUrl';
import { styles } from './styles';

export const HeroImage = (props) => {
  const {
    isMobile,
    type,
    isPublished,
    hasHeroImage,
    ctliveEventId,
  } = props;

  const imgUrl = heroImageUrl(
    type || 'Running',
    isMobile,
    isPublished && hasHeroImage && ctliveEventId
  );

  return (
    <div style={styles.wrapper(isMobile)}>
      <div style={styles.heroImageBlured(imgUrl, isMobile)}/>
      <div style={styles.heroImage(imgUrl, isMobile, hasHeroImage)}/>
      {props.children}
      <div style={styles.gradientOverlay}/>
    </div>
  );
};
